import {Injectable} from '@angular/core';
import {transformJsonToForm, transformJsonToFormPersonas} from "../interfaces/field-types";
import {of} from "rxjs";
import {JsonUtilsService} from "../../../../services/json-utils.service";

@Injectable()
export class FieldsParserService {

    constructor(private jsonUtilsService: JsonUtilsService) {
    }

    parseFields(jsonPayload: string) {
        console.log(`#DEBUG parseFields()`)
        let parsedForm;
        const parsedPayload = this.jsonUtilsService.parseJson(jsonPayload);
        // console.log(`#DEBUG jsonPayload ->${JSON.stringify(jsonPayload)}`);
        // console.log(`#DEBUG parsedPayload ->${JSON.stringify(parsedPayload)}`);
        if (parsedPayload) {
            parsedForm = transformJsonToForm(parsedPayload);
            // console.log(`#DEBUG parsedForm ->${JSON.stringify(parsedForm)}`);
            return of(parsedForm!.sort((a, b) => a.order - b.order))
        } else {
            return of([])
        }
    }

    parseFieldsPersonas(jsonPayload: string) {
        console.log(`#DEBUG parseFieldsPersonas()`);
        let parsedForm;
        const parsedPayload = this.jsonUtilsService.parseJson(jsonPayload);
        // console.log(`#DEBUG jsonPayload -> ${JSON.stringify(jsonPayload)}`);
        // console.log(`#DEBUG parsedPayload -> ${JSON.stringify(parsedPayload)}`);
        if (parsedPayload) {
            // Transformamos el JSON en instancias de FieldPersonas
            parsedForm = transformJsonToFormPersonas(parsedPayload);
            // console.log(`#DEBUG parsedForm -> ${JSON.stringify(parsedForm)}`);
            return of(parsedForm.sort((a, b) => a.step - b.step));
        } else {
            return of([]);
        }
    }


}

